import { render, staticRenderFns } from "./filter-call-activity.vue?vue&type=template&id=28408c36&scoped=true"
import script from "./filter-call-activity.vue?vue&type=script&lang=js"
export * from "./filter-call-activity.vue?vue&type=script&lang=js"
import style0 from "./filter-call-activity.vue?vue&type=style&index=0&id=28408c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28408c36",
  null
  
)

export default component.exports